import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthFactoryService } from 'src/app/auth/authFactory.service';
import { APIService } from 'src/app/core/api/general.service';
import { IGdsCredential, IOffices, IStations } from 'src/app/core/models/IGdsCredentials.model';
import { LayoutService } from 'src/app/layout/services/layout.service';
import { ItineraryService } from 'src/app/search-result/services/itinerary.service';
import { IAuthStatusToken } from 'src/app/auth/models/authStatusToken.model';
import {
  IBookingCredentialsData,
  IBookingCredentialsState
} from 'src/app/core/models/booking-credentials.model';

@Component({
  selector: 'app-booking-credentials',
  templateUrl: './booking-credentials.component.html'
})
export class BookingCredentialsComponent implements OnDestroy {
  @Input() index: number;
  @Input() formDisabled: boolean = false;

  @Output() credentialsData = new EventEmitter<IBookingCredentialsData>();
  @Output() formReady = new EventEmitter<boolean>();

  subscriptions = new Subscription();

  form: FormGroup;
  token: string;
  office = '';
  station = '';
  submitted = false;
  defaultGdsCredentials: IGdsCredential;
  listOfOficces: IOffices[] = [];
  listOfStations: IStations[] = [];
  dutyCode: number = 5;

  constructor(
    public authFactoryService: AuthFactoryService,
    private apiService: APIService,
    private itineraryService: ItineraryService,
    private layoutService: LayoutService
  ) {}

  ngOnInit() {
    this.callComponentSubscriptions();
  }

  callComponentSubscriptions() {
    this.subscriptions.add(
      this.layoutService.getBookingCredentialsState().subscribe((state) => {
        this.buildForm(state);
      })
    );

    this.subscriptions.add(
      this.authFactoryService.getSesionStatusToken().subscribe((status) => {
        const parsedStatusToken: IAuthStatusToken = {
          isAuthenticated: status[0],
          accessToken: status[1]
        };

        this.token = parsedStatusToken.accessToken;
      })
    );

    this.subscriptions.add(
      this.apiService.getGdsCredentials(this.token).subscribe((res) => {
        this.defaultGdsCredentials = res.body[0];
        this.listOfOficces = this.defaultGdsCredentials.parameter.offices;
        this.listOfOficces.forEach((res) => {
          res.name = `${res.country.name} (${res.description})`;
          res.code = res.ipcc;
        });
      })
    );
  }

  changeAction() {
    this.listOfStations = [];
    this.office = this.form.controls.office.value;
    let officeFiltered = this.listOfOficces?.find(
      (x) => x.ipcc === this.form.controls.office.value
    );

    this.form.controls.pcc.setValue(officeFiltered?.pcc);
    this.form.controls.ipcc.setValue(officeFiltered?.ipcc);

    this.itineraryService.dispatchSetOfficeCountry(officeFiltered);
    this.form.controls.station.setValue(officeFiltered?.stations[0]?.number);
    officeFiltered?.stations.forEach((option) => {
      let stationAdd: IStations = {
        name: option.name + ' - ' + option.number,
        code: option.number,
        number: option.number
      };
      this.listOfStations.push(stationAdd);
    });
    this.station = this.listOfStations[0]?.number;
    this.form.controls.office.setValue(officeFiltered.country.isoCode);
  }

  changeActionStation() {
    this.station = this.form.controls.station.value;
  }

  buildForm(state: IBookingCredentialsState) {
    this.form = new FormGroup({
      username: new FormControl(state?.data.username, [
        Validators.required,
        Validators.maxLength(6)
      ]),
      password: new FormControl(state?.data.password, [
        Validators.required,
        Validators.maxLength(8)
      ]),
      sine: new FormControl(state?.data.sine, Validators.required),
      dutyCode: new FormControl(this.dutyCode),
      office: new FormControl(state?.data.office, Validators.required),
      station: new FormControl(state?.data.station, Validators.required),
      pcc: new FormControl(state?.data.pcc),
      ipcc: new FormControl(state?.data.ipcc)
    });

    this.subscriptions.add(
      this.form.valueChanges.subscribe((data) => {
        this.credentialsData.emit(data);
        this.formReady.emit(this.form.valid);
      })
    );
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}
